// extracted by mini-css-extract-plugin
export default {"root":"IconBedBreakfast_root__2MfFC"};